import { request } from "./client";
import type { PhoneStatus } from "./types";

export const accountApi = {
  getPhone: () => request<PhoneStatus>("/api/account/phone"),
  startPhoneVerify: (phone: string, currentPassword: string) =>
    request<{ ok: true; phone: string; expiresInSec: number; debugCode?: string }>("/api/account/phone/start", {
      method: "POST",
      body: JSON.stringify({ phone, currentPassword }),
    }),
  confirmPhoneVerify: (code: string) =>
    request<{ ok: true; phone: string; phoneVerified: true }>("/api/account/phone/confirm", {
      method: "POST",
      body: JSON.stringify({ code }),
    }),
  unlinkPhone: (currentPassword: string) =>
    request<{ ok: true; phone: null; phoneVerified: false }>("/api/account/phone/unlink", {
      method: "POST",
      body: JSON.stringify({ currentPassword }),
    }),
  setSmsTarget: (siteId: string | null) =>
    request<{ ok: true; smsTargetSiteId: string | null }>("/api/account/phone/sms-target", {
      method: "PATCH",
      body: JSON.stringify({ siteId }),
    }),
  enableMfa: (currentPassword: string) =>
    request<{ ok: true; mfaSmsEnabled: true }>("/api/auth/mfa/sms/enable", {
      method: "POST",
      body: JSON.stringify({ currentPassword }),
    }),
  disableMfa: (currentPassword: string) =>
    request<{ ok: true; mfaSmsEnabled: false }>("/api/auth/mfa/sms/disable", {
      method: "POST",
      body: JSON.stringify({ currentPassword }),
    }),
  resendVerification: (email: string) =>
    request<{ message: string }>("/api/auth/resend-verification", {
      method: "POST",
      body: JSON.stringify({ email }),
    }),
};
